import { useState } from "react";
import classes from "../../styles/History.module.css";
import Slot from "./Slot";
import Description from "./Description";
import Wins from "./Wins";
import { Currency } from "../../utils";

const Spin: React.FC<{ data: any; index: number }> = ({ index, data }) => {
  const wins = data.wins[index] ?? [];
  const [selectedWin, setSelectedWin] = useState(wins[0]);
  const pillHover = (index: number) => setSelectedWin(wins[index]);
  const payout = data.payouts ? data.payouts[index] : 0;
  const view = data.views[index] ?? [];
  const marked = data.marked[index] ?? [];
  const line = selectedWin?.line ?? [];
  const highlighted = selectedWin?.positions ?? [];
  const code = data.currencyId;
  const symbol = data.symbol || data.currencySymbol || "";
  const currency = { code, symbol } as Currency;

  return (
    <div className={classes.spin}>
      <Slot view={view} highlighted={highlighted} muted={line.concat(marked)} />
      <div className={classes["spin-info"]}>
        <Description data={data} visible={index === 0} currency={currency} />
        <Wins
          payout={payout}
          wins={wins}
          extraInfo={data.extraInfo}
          selectedWin={selectedWin}
          currency={currency}
          onHover={pillHover}
          spinIndex={index}
        />
      </div>
    </div>
  );
};

export default Spin;
